import React, { useEffect, useState } from 'react';
import { ErrorMessage } from '../errors/ErrorMessage';
import { Dropzone, Props as DropzoneProps } from './Dropzone';
import { UploadError } from './FileUploader';
import styles from './Dropzone.module.scss';

export const DropzoneWithErrors = ({
    additionalErrors = [],
    ...props
}: Props) => {

    const [isSuccess, setIsSuccess] = useState(false);
    const [errors, setErrors] = useState<UploadError[]>([]);

    const handleUploads = (files: File[]) => {
        props.onChange(files);
        setErrors([]);
        setIsSuccess(true);
    };

    const handleErrors = (errors: UploadError[]) => {
        setErrors(errors);
    };

    useEffect(() => {

        if (additionalErrors.length > 0 || errors.length > 0) {
            setIsSuccess(false);
        }

        if (isSuccess) {
            props.onError(errors);
        }

    }, [additionalErrors, errors]);

    const allErrors = [...errors.map(e => e.text), ...additionalErrors.map(e => e.text)];

    return (
        <>
            <Dropzone
                {...props}
                isSuccess={isSuccess}
                onError={handleErrors}
                onChange={handleUploads} />

            {allErrors.length > 0 && (
                <ErrorMessage className={styles.alert}>
                    {allErrors}
                </ErrorMessage>
            )}
        </>
    );
};

export type Props = DropzoneProps & {
    additionalErrors?: UploadError[];
};